import http from '@/http/http.js'
let baseURL1 = ''
let baseURL2 = ''
let baseURL3 = ''
let baseURL4 = ''
let baseURL5 = ''
if (process.env.NODE_ENV == 'development') {
	//开发环境
	baseURL1 = '/api/web/action/qcapi/springBoard'
	baseURL2 = '/api/web/action/icapi/springBoard'
	baseURL3 = '/api/web/opreceive/need/springBoard'
	baseURL4 = '/api/web/action/product/springBoard'
	baseURL5 = '/api/web/action/regapi/springBoard'
} else if (process.env.NODE_ENV == 'production') {
	//生产环境
	baseURL1 = '/web/action/qcapi/springBoard'
	baseURL2 = '/web/action/icapi/springBoard'
	baseURL3 = '/web/opreceive/need/springBoard'
	baseURL4 = '/web/action/product/springBoard'
	baseURL5 = '/web/action/regapi/springBoard'

}

//icp方案提交
export function submitIcpProgramme(params, needNo, bizType) {
	console.log(bizType)
	return http.post(baseURL1, {
		actionType: 'submitIcpProgramme', //固定写法就行
		actionBody: {
			needNo: needNo,
			solutionContent: {
				bizType: bizType,
				solution: params,
			},
		},
	})
}

//百度文网文提交方案
export function ncSubmitSolution(params, needNo) {
	return http.post(baseURL1, {
		actionType: 'ncSubmitSolution',
		actionBody: {
			needNo: needNo,
			solutionContent: {
				solution: params,
			},
		},
	})
}

//百度广播电视提交方案
export function rtSubmitSolution(params, needNo) {
	return http.post(baseURL1, {
		actionType: 'rtSubmitSolution',
		actionBody: {
			needNo: needNo,
			solutionContent: {
				solution: params,
			},
		},
	})
}



//服务商关闭icp方案
export function abolishIcpProgramme(params) {
	return http.post(baseURL1, {
		actionType: 'abolishIcpProgramme',
		actionBody: params,
	})
}

//获取方案列表（获取用户所有方案）
//全部服务单
export function getProgrammeListByUser(params) {
	return http.post(
		// 'http://gsb.qifu.gongsibao.com:4012/web/action/icapi/springBoard',
		baseURL2,
		{
			actionType: 'getProgrammeListByUser',
			actionBody: {
				pageIndex: '1',
				pageSize: '100',
				needNo: '',
				solutionNo: '',
				orderNo: '',
				status: params,
			},
		}
	)
}

//根据需求产看方案详情
//需求详情
export function getProgrammeInfoByChannelNeedNo(params) {
	return http.post(baseURL1, {
		actionType: 'getProgrammeInfoByChannelNeedNo',
		actionBody: {
			needNo: params,
		},
	})
}

//获取方案详情
export function getNeedSolutionDetailByUser(params) {
	return http.post(baseURL1, {
		actionType: 'getNeedSolutionDetailByUser',
		actionBody: {
			solutionNo: params,
		},
	})
}

//icp材料提交

export function submitIcpMaterial(params) {
	return http.post(baseURL1, {
		actionType: 'submitIcpMaterial',
		actionBody: params,
	})
}

//服务商关闭icp需求
export function needCloseIcp(params) {
	return http.post(baseURL3, {
		actionType: 'needCloseIcp',
		actionBody: params,
	})
}

// //百度文网文/广播电视 服务商关闭需求
// export function bdNeedClose(params) {
// 	return http.post(baseURL3, {
// 		actionType: 'bdNeedClose',
// 		actionBody: params,
// 	})
// }

//获取需求详情
export function getItemByNeedNo(params) {
	return http.post(baseURL3, {
		actionType: 'getItemByChannelNeedNo',
		actionBody: {
			needNo: params,
		},
	})
}

//icp通知状态变更
export function acceptIcpPartnerNotification(params) {
	return http.post(baseURL1, {
		actionType: 'acceptIcpPartnerNotification',
		actionBody: params,
	})
}

//新增沟通记录
export function writeCommunicationLog(params) {
	return http.post(baseURL3, {
		actionType: 'writeCommunicationLog',
		actionBody: params,
	})
}

//获取沟通记录
export function queryExpertApplyCommunicationLogs(params) {
	return http.post(baseURL3, {
		actionType: 'queryExpertApplyCommunicationLogs',
		actionBody: params,
	})
}


//方案询价
export function getaliicpProduce(params) {
	return http.post(baseURL3, {
		actionType: 'getaliicpProduce',
		actionBody: params,
	})
}
//阿里文网文方案询价
export function getProductPrice(params) {
	return http.post(baseURL4, {
		actionType: 'getProductPrice',
		actionBody: params,
	})
}

/**
 * 
 *---------  百度云工商
 */


//工商新增沟通记录
export function gongshangwriteCommunicationLog(params) {
	return http.post(baseURL5, {
		actionType: 'regWriteCommunicationLog',
		actionBody: params,
	})
}

//工商获取沟通记录
export function gongshangqueryExpertApplyCommunicationLogs(params) {
	return http.post(baseURL5, {
		actionType: 'regQueryExpertCommunicationLogs',
		actionBody: params,
	})
}

//工商提交方案
export function gongshangSubmitSolution(params, needNo) {
	return http.post(baseURL5, {
		actionType: 'regSubmitSolution',
		actionBody: {
			needNo: needNo,
			solutionList: params,
		},
	})
}

// 工商关闭需求
export function gongshangneedClose(params) {
	return http.post(baseURL5, {
		actionType: 'regNeedClose',
		actionBody: params,
	})
}

// 工商询价
export function gongshanggetProductPrice(params) {
	return http.post(baseURL4, {
		actionType: 'getRegProducePrice',
		actionBody: params,
	})
}


//易名icp方案询价接口
export function getymicpProduce(params) {
	return http.post(baseURL3, {
	// return http.post("/api/web/opreceive/need/springBoard", {
		actionType: 'getymicpProduce',
		actionBody: params,
	})
}
